import { CSSProperties, FC, ReactNode, useMemo } from 'react';
import Spinner from '../spinner';

interface Props {
  children?: ReactNode;
  active: Boolean;
  spinner?: React.ReactNode;
}

const LoadingOverlay: FC<Props> = ({
  children,
  active,
  spinner = <Spinner />,
}) => {
  const overlayStyles: CSSProperties = useMemo(
    () => ({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: active ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(232, 237, 238, 0.7)',
      zIndex: 48,
      transition: 'opacity 0.3s ease-in-out',
      opacity: active ? 1 : 0,
    }),
    [active]
  );

  const wrapperStyles: CSSProperties = {
    position: 'relative',
    padding: 0,
    overflow: 'auto',
  };

  return (
    <div style={wrapperStyles}>
      {children}
      <div style={overlayStyles}>{spinner}</div>
    </div>
  );
};

export default LoadingOverlay;
